<template>
    <x-data-table
        class="no-row-hover"
        :headers="obligorTableHeaders"
        :items="value"
        hide-actions
    >
        <template v-slot:no-data>
            <p class="error-message text-xs-center">No data found</p>
        </template>
        <template v-slot:items="props">
            <tr>
                <td>
                    {{ props.item.name }}
                </td>
                <td>
                    {{ (props.item.address) ? props.item.address.line1 : 'N/A' }}
                </td>
                <td v-if="obligor">
                    {{ getSubLimit(props.item.pivot.sub_limit) }}
                </td>
            </tr>
        </template>
    </x-data-table>
</template>

<script>

export default {
    name: 'ObligorDataList',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        obligor: Boolean,
        currencyCode: String
    },
    computed: {
        obligorTableHeaders() {
            const obligorTableHeaders = [
                {
                    text: 'Name',
                    value: 'obligor.name'
                },
                {
                    text: 'Address',
                    value: 'obligor.address'
                },
            ];
            if (this.obligor) {
                obligorTableHeaders.push(
                    {
                        text: 'Sub Limit',
                        value: 'sub_limit'
                    }
                );
            }
            return obligorTableHeaders;
        }
    },
    methods: {
        getSubLimit(subLimit) {
            if (!subLimit) {
                return 'N/A';
            }

            return this.$options.filters.currency(subLimit, this.currencyCode)
        }
    }
}
</script>
